import { IComposableAnalyticsGlobalFilters } from 'wisestep-api';
import { formattedDate } from 'wisestep-base';

const getTimePeriodLabelsFromKey = (
  key: string,
  filters?: IComposableAnalyticsGlobalFilters,
  title?: string
) => {
  if (filters?.fromDate && filters?.toDate)
    return title
      ? `${title} for the period From ${formattedDate(filters.fromDate)} to ${formattedDate(
          filters.toDate
        )}`
      : `From ${formattedDate(filters.fromDate)} to ${formattedDate(filters.toDate)}`;
  const keyLower = key.toLowerCase();
  if (keyLower.includes('1hour') || keyLower.includes('1h'))
    return title ? `${title} for the period Last 8 Hours` : 'Last 8 Hours';
  if (keyLower.includes('8hour') || keyLower.includes('8h'))
    return title ? `${title} for the period Last 8 Hours` : 'Last 8 Hours';
  if (keyLower.includes('today')) return title ? `${title} for the period Today` : 'Today';
  if (keyLower.includes('24hour') || keyLower.includes('24h'))
    return title ? `${title} for the period Last 24 Hours` : 'Last 24 Hours';
  if (keyLower.includes('wtd') || keyLower.includes('this_week'))
    return title ? `${title} for the period This Week` : 'This Week';
  if (keyLower.includes('7days') || keyLower.includes('7d'))
    return title ? `${title} for the period Last 7 Days` : 'Last 7 Days';
  if (keyLower.includes('30days') || keyLower.includes('30d'))
    return title ? `${title} for the period Last 30 Days` : 'Last 30 Days';
  if (keyLower.includes('mtd') || keyLower.includes('month_till_date'))
    return title ? `${title} for the period MTD` : 'MTD';
  if (keyLower.includes('qtd') || keyLower.includes('current_quarter'))
    return title ? `${title} for the period QTD` : 'QTD';
  if (keyLower.includes('last_quarter') || keyLower.includes('lastquarter'))
    return title ? `${title} for the period Last Quarter` : 'Last Quarter';
  if (
    keyLower.includes('this_year') ||
    keyLower.includes('ytd') ||
    keyLower.includes('year_till_date')
  )
    return 'YTD';
  if (keyLower.includes('last_year') || keyLower.includes('lastyear'))
    return title ? `${title} for the period Last Year` : 'Last Year';
  if (keyLower.includes('365d'))
    return title ? `${title} for the period Last 365 Days` : 'Last 365 Days';
  return 'Unspecified';
};

export default getTimePeriodLabelsFromKey;
